var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12 0C5.379 0 0 5.379 0 12s5.379 12 12 12 12-5.379 12-12S18.621 0 12 0Zm0 1.043c6.057 0 10.957 4.9 10.957 10.957S18.057 22.957 12 22.957 1.043 18.057 1.043 12 5.943 1.043 12 1.043Zm5.211 5.733a.522.522 0 0 0-.426.236l-5.322 7.845-3.804-3.53a.522.522 0 1 0-.71.766l4.694 4.355 6.006-8.851a.522.522 0 0 0-.438-.82Z"
  })));
};
export { SvgCheckCircle as ReactComponent };